import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import { FormPerfil } from "../modulos/perfil/Form";
import { Notificaciones } from "../modulos/perfil/Notificaciones";
import useUser from "../../hooks/useUser";
import { Badge } from "@mui/material";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ span: 3 }}>
          <Typography component='span' variant='body2'>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const MiPerfil = () => {
  const userId = useParams();

  const {notificacionesPendientes} = useUser();

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  //

  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }} >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            centered
          >
            <Tab className="badgeBio" overlap="circular" label={<Badge badgeContent={notificacionesPendientes} >Notificaciones</Badge>} {...a11yProps(0)} />
            <Tab label="Datos" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}  component='span' variant='body2' >
         <Notificaciones />
        </TabPanel>
        <TabPanel value={value} index={1} component='span' variant='body2'>
          <FormPerfil accion="update" userId={userId.id} />
        </TabPanel>
      </Box>
    </div>
  );
};

